import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';  ///----------- for searching pop up -----------
import { PreparationHDModel } from 'src/app/models/PreparationHDModel';
import { LocalStorageService } from 'ngx-webstorage';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';         ///----------- for searching pop up -----------
import { formatDate } from '@angular/common';
import { TransactionsService } from 'src/app/services/TransactionsService';
import { TransactionsModel } from 'src/app/models/TransactionsModel';

@Component({
  selector: 'app-paymentssearch',
  templateUrl: './paymentssearch.component.html',
  styleUrls: ['./paymentssearch.component.css']
})
export class PaymentssearchComponent implements OnInit {
  trtype = 'Exp';
  trserial = '' ;
  trdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  trkind = '' ;
  trvalue = 0 ;
  trchno = '' ;
  trchduedate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  trcln_supp = '' ;
  supname ='';
  trbank = '' ;
  trclass = '' ;
  trdoctor = '' ;
  trhospital = '' ;
  trdescription = '' ;
  compcode = '1' ;
  userid = '' ;
  modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');

  transactionsList: TransactionsModel[] = [];

  @Output() submitClicked = new EventEmitter<any>();

  constructor(public dialogRef: MatDialogRef<PaymentssearchComponent>,   ///----------- for searching pop up -----------
  public transactionsservice: TransactionsService,
  public transactions: TransactionsModel,
  public storage: LocalStorageService,
  @Inject(MAT_DIALOG_DATA)                                     ///----------- for searching pop up -----------
  public transactionSelectedData: TransactionsModel) { }

  ngOnInit(): void {
    this.retriveTransTop();
  }
  retriveTransTop(){

    this.transactionsservice.getTransactionsLookupTop("Exp",this.storage.retrieve('stgcompCode')).subscribe((data: TransactionsModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.transactionsList[i] = data[i];
        data[i].trdate = formatDate(data[i].trdate, 'yyyy/MM/dd', 'en');
      }

    })
  }
  retriveIPrepLookUp(){
    this.transactionsList = [];
    this.transactionsservice.getTransactionsLookup(this.trtype, this.trserial, this.supname,this.compcode).subscribe((data: TransactionsModel[]) => {
    for (let i = 0; i < data.length; i++) {
      this.transactionsList[i] = data[i];
      data[i].trdate = formatDate(data[i].trdate, 'yyyy/MM/dd', 'en');

    }
    console.log(data);
  })
  }

  SelectItem(prep: TransactionsModel){
    this.transactionSelectedData.trserial = prep.trserial
    this.transactionSelectedData.trdate = prep.trdate
    this.transactionSelectedData.trbank= prep.trbank
    this.transactionSelectedData.trcln_supp= prep.trcln_supp
    this.transactionSelectedData.supname= prep.supname

    this.submitClicked.emit(this.transactionSelectedData);
    this.dialogRef.close();
  }
}
